
    import { defineComponent } from 'vue';
    import { MobBT } from "../babylon/MobBT";
  
  export default defineComponent({
      name: 'BabylonMetaRoom',
      mounted() {
        const canvas = document.querySelector("canvas")!;
        const loader = document.getElementById("loadingContainerMobBT") as HTMLElement;
        // const loadingBack = document.getElementById("loadingBack") as HTMLElement;
        const loadAnim = document.getElementById("loadAnim") as HTMLElement;
        new MobBT(canvas, loader, loadAnim);
      }
    });
  